import { UserTypes } from "actions/types";
import axios from "axios";
import { fromJS } from "immutable";
import { serverError } from "actions/error";
import { postToParent } from "utils/parentMessaging";
import { logError } from "utils/logError";

// The headers, url and method for a links-slice route. Null (and logged under `context`) when the
// config slice is not loaded enough to build the request.
function linkRequest(getState, route, context) {
  try {
    const host = getState().config.get("host");
    const headers = getState()
      .config.get("headers")
      .toJSON();
    return {
      headers,
      url: `${host}${route.get("href")}`,
      method: route.get("method"),
    };
  } catch (error) {
    logError(`${context}: read headers/route`, error);
    return null;
  }
}

export function fetchBalance() {
  return (dispatch, getState) => {
    // Not every operator exposes a balance link, and callers fire this on every game close.
    const route = getState().links?.get("getBalance");
    if (!route) {
      return;
    }
    const request = linkRequest(getState, route, "fetchBalance");
    if (!request) {
      return;
    }
    const { headers, url, method } = request;

    dispatch({
      type: UserTypes.FETCH_BALANCE,
      payload: {
        route,
        url,
      },
    });
    return axios({
      method,
      headers,
      url,
    })
      .then(({ data }) => {
        return dispatch(
          setBalance(
            fromJS({
              route,
              data,
            })
          )
        );
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function setBalance(payload) {
  return (dispatch, getState) => {
    return dispatch({
      type: UserTypes.SET_BALANCE,
      payload: payload,
    });
  };
}

export function wlFetchProfile() {
  return (dispatch, getState) => {
    // Only white-label operators expose a profile link.
    const route = getState().links?.get("wl.profile");
    if (!route) {
      return;
    }
    const request = linkRequest(getState, route, "wlFetchProfile");
    if (!request) {
      return;
    }
    const { headers, url, method } = request;

    dispatch({
      type: UserTypes.FETCH_PROFILE,
      payload: {
        route,
        url,
      },
    });
    return axios({
      method,
      headers,
      url,
    })
      .then(({ data }) => {
        return dispatch(
          setProfile(
            fromJS({
              route,
              data,
            })
          )
        );
      })
      .catch((error) => {
        dispatch(serverError(error));
        throw error;
      });
  };
}

export function setProfile(payload) {
  return (dispatch, getState) => {
    return dispatch({
      type: UserTypes.SET_PROFILE,
      payload: payload,
    });
  };
}

export function broadcastCashier() {
  postToParent({
    type: "CASHIER_REQUESTED",
  });

  return (dispatch, getState) => {
    return dispatch({
      type: UserTypes.BROADCAST_SHOW_CASHIER,
    });
  };
}

export function broadcastNewUpdate(version, buildNo) {
  postToParent({
    type: "VERSION_UPDATED",
    payload: {
      version: version,
      build: buildNo,
    },
  });

  return (dispatch, getState) => {
    return dispatch({
      type: UserTypes.BROADCAST_NEW_UPDATE,
    });
  };
}

export function broadcastSwitchDevice(params, data) {
  return (dispatch, getState) => {
    params.location.pathname = params.location.pathname.replace([
      getState().config,
    ]);
    let strRemove = `/${getState().config.get(
      "locale"
    )}/${getState().security.get("sessionId")}`;
    let postMsgParams = { location: {} };

    if (params.location.pathname) {
      postMsgParams.location.pathname = params.location.pathname.replace(
        strRemove,
        ""
      );
    }

    if (params.location.search) {
      postMsgParams.location.search = params.location.search;
    }

    data === undefined
      ? (postMsgParams.gameId = null)
      : (postMsgParams.gameId = data);

    postToParent({
      type: `SWITCH_DEVICE_REQUESTED`,
      payload: postMsgParams,
    });
    return dispatch({
      type: UserTypes.BROADCAST_SWITCH_DEVICE,
      payload: {
        params,
      },
    });
  };
}

export function broadcastGameMode(gameMode) {
  postToParent({
    type: `${gameMode}_PLAY_SELECTED`,
  });
  return (dispatch, getState) => {
    return dispatch({
      type: UserTypes.BROADCAST_GAME_MODE,
    });
  };
}

export function broadcastSessionExpired() {
  postToParent({
    type: "SESSION_EXPIRED",
  });

  return (dispatch, getState) => {
    return dispatch({
      type: UserTypes.BROADCAST_SESSION_EXPIRED,
    });
  };
}
